import { format, formatDistanceToNow } from 'date-fns';

// Locale-formatted number. Mirrors ScopeStep.jsx.
export const fmt = n => (n == null ? '—' : Number(n).toLocaleString('fr-FR'));

// Duration in seconds → compact human string. Copied from ProgressStep.jsx.
export const fmtDuration = seconds => {
  if (seconds == null || Number.isNaN(seconds)) return '—';
  if (seconds < 60) return `${Math.round(seconds)}s`;
  if (seconds < 3600) {
    const m = Math.floor(seconds / 60);
    const s = Math.round(seconds % 60);
    return `${m}m ${s}s`;
  }
  const h = Math.floor(seconds / 3600);
  const m = Math.round((seconds % 3600) / 60);
  return `${h}h ${m}m`;
};

// "3 minutes" — no "about" prefix, safe with null.
export const fmtRelative = ts => {
  if (!ts) return '—';
  try {
    return formatDistanceToNow(new Date(ts));
  } catch {
    return '—';
  }
};

// "12:34:56"
export const fmtClock = ts => {
  if (!ts) return '—';
  try {
    return format(new Date(ts), 'HH:mm:ss');
  } catch {
    return '—';
  }
};

// "12:34"
export const fmtShortClock = ts => {
  if (!ts) return '';
  try {
    return format(new Date(ts), 'HH:mm');
  } catch {
    return '';
  }
};
